export default "__VITE_ASSET__C8xKMT39__"